const DEFAULT_PRESERVED_LOCAL_STORAGE_KEYS = [
    'remember_login_account',
    'lang',
    'appVersion',
    'wa_hide_ack',
];

const ACCOUNT_SCOPED_LOCAL_STORAGE_PREFIXES = [
    'wa_login_user_',
    'wa_unread_map_',
    'email_badge_last_seen_total_',
    'spaceSize_',
    'userDataInformation_',
    'allProductList_',
    'allUserVip_',
    'selectTargetProduct_',
    'existingValueVip_',
    'upsellVipChecked_',
];

function shouldPreserveKey(key, exactKeys = [], prefixes = []) {
    if (!key) return false;
    if (Array.isArray(exactKeys) && exactKeys.includes(key)) return true;
    if (Array.isArray(prefixes) && prefixes.some(prefix => prefix && key.startsWith(prefix))) return true;
    return false;
}

function backupStorage(storageLike, exactKeys = [], prefixes = []) {
    const backup = {};
    try {
        for (let i = 0; i < storageLike.length; i++) {
            const key = storageLike.key(i);
            if (!shouldPreserveKey(key, exactKeys, prefixes)) continue;
            backup[key] = storageLike.getItem(key);
        }
    } catch (e) {
    }
    return backup;
}

function restoreStorage(storageLike, backup = {}) {
    if (!backup || typeof backup !== 'object') return;
    try {
        Object.keys(backup).forEach((key) => {
            const value = backup[key];
            if (value === undefined || value === null) return;
            storageLike.setItem(key, value);
        });
    } catch (e) {
    }
}

export function getDefaultPreservedLocalStorageKeys() {
    return [...DEFAULT_PRESERVED_LOCAL_STORAGE_KEYS];
}

export function getAccountScopedLocalStoragePrefixes() {
    return [...ACCOUNT_SCOPED_LOCAL_STORAGE_PREFIXES];
}

export function clearBrowserStorageWithBackup({
    preserveLocalKeys = [],
    preserveLocalPrefixes = [],
    preserveSessionKeys = [],
    preserveSessionPrefixes = [],
} = {}) {
    const localBackup = backupStorage(localStorage, preserveLocalKeys, preserveLocalPrefixes);
    const sessionBackup = backupStorage(sessionStorage, preserveSessionKeys, preserveSessionPrefixes);

    try {
        localStorage.clear();
    } catch (e) {
    }

    try {
        sessionStorage.clear();
    } catch (e) {
    }

    return {
        localBackup,
        sessionBackup,
    };
}

export function restoreBrowserStorageBackup({localBackup = {}, sessionBackup = {}} = {}) {
    restoreStorage(localStorage, localBackup);
    restoreStorage(sessionStorage, sessionBackup);
}

export function resetWindowLevelAccountCache() {
    try {
        window.socketTarget = null;
    } catch (e) {
    }
    try {
        window.__waActiveRoomId = '';
    } catch (e) {
    }
    try {
        window.__waMessageBuffer = [];
    } catch (e) {
    }
    try {
        window.__waHandledMessageIds = new Map();
    } catch (e) {
    }
}
